//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import mainMenuTab from "@/components/mainMenuTab";
import cardbox from '@/components/ui/cardbox';


export default {
    components: {mainMenuTab,cardbox},
    data(){
        return {
            userInfo: {
                role: '',
                user_id: '',
                user_name: '',
                portrait: '',
                openid: '',
                no_addr: '',
                last_login: '',
            },
            basicCount: {
                coupon: 0,
                yakuang: 0,
                integral: 0,

                waitOrder: 0,
                dispatchOrder: 0,
                order: {},
            }

        }
    },
    methods:{

        // 查询优惠券数量
        queryCouponCount(){

            const opts = {
                url: api.myCouponCount,
                data: {},
                type: 'get',
            }
            common.query(opts).then(res=>{
                this.basicCount.coupon = res.data.count;
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 查询积分总数
        queryIntegralCount(){

            const opts = {
                url: api.myIntegralCount,
                type: 'get',
            }
            common.query(opts).then(res=>{
                this.basicCount.integral = res.data.sum;
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 查询压框数量
        queryYakuangCount(){

            const opts = {
                url: api.myYakuangCount,
                type: 'get',
            }
            common.query(opts).then(res=>{
                this.basicCount.yakuang = res.data.count;
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 查询订单数量
        queryOrderCount(){

            const opts = {
                url: api.myOrderCount,
                data: {
                    // status: 11,
                },
                type: 'get',
            }
            common.query(opts).then(res=>{
                this.basicCount.order = res.data.count;
            },res=>{
                this.$vux.toast.text(res.message);
            })
        },

        // 查询我的个人信息
        queryMyInfo(){

            const opts = {
                url: api.myInfo,
                data: {},
                type: 'get'
            }
            common.query(opts).then(res=>{
                this.userInfo = res.data;
                this.userInfo.portrait = res.data.portrait ? res.data.portrait+'?x-oss-process=image/resize,m_fill,h_100,w_100' : '/static/img/head.gif';
                this.userInfo.last_login = common.formatDate(new Date(res.data.last_login * 1000));
                common.storageJson("userInfo",res.data);
            },res=>{
                this.$vux.toast.text(res.message);
            });
        },

    },
    mounted(){

        this.queryMyInfo();
        this.queryCouponCount();
        this.queryYakuangCount();
        this.queryIntegralCount();
        this.queryOrderCount();

    },
}




// WEBPACK FOOTER //
// ./src/views/member/my.vue